// The review prompt prepended to a transcript when a reviewer wants an LLM to
// audit the projection. Kept next to the renderer so the prompt and the
// transcript format evolve together. Engineering-internal — see
// `docs/calculation-projection-prompt.md`.

export const TRANSCRIPT_REVIEW_PROMPT = `You are reviewing a long-term-care insurance policy projection for ENGINEERING
correctness, not customer suitability. Below is a plain-text transcript with five
sections: a header block (policy terms), a returns summary, year snapshots, a
month-by-month table, and a product brief.

Treat the **product brief as ground truth** for how this product is supposed to
behave. Your job is to find places where the NUMBERS contradict the brief, the
header terms, or basic accounting identities — and to flag anything questionable.

Check at least these, citing specific row indices / values:

1. Brief conformance — does every "Things to eyeball" item in the brief hold?
   (e.g. base_pool drawn fully before eob; db reduced only by the stated pool;
   flat vs. inflating pools; indemnity vs. reimbursement payout behavior.)
2. Balance identities — for each row, base_pool/eob/db closing = opening + delta;
   deltas tie to payouts and care cost; running balances never go negative.
3. Returns summary vs. rows — do the aggregates reconcile with the month stream
   (total payout, ineligible/OOP, remaining death benefit)?
4. Inflation — do year-snapshot daily benefits, caps, and pool ceilings grow at
   the header's stated rates/caps, applied to the right base, starting the right
   year? Flag a cap kicking in a year early/late.
5. Eligibility & timing — out_of_pocket buckets (lt-2-adl / in-wp / il-not-covered
   / pre-policy) and milestones (claim-start, ep-lump, pool-exhausted, etc.) fire
   in a sensible order and at plausible months. Flag e.g. an EP lump firing twice,
   payout before the WP is served, or OOP after the pool should cover it.
6. Reimbursement vs. indemnity — is payout vs. care_cost consistent with the
   payout_model in the header?

Output a short, ranked list. For each finding: (a) the row(s)/value, (b) what's
wrong or suspicious, (c) why, (d) confidence (high/medium/low). Separate
"likely bugs" from "worth a look." If something is correct but counterintuitive
(e.g. negative ineligible on an ep-lump row), say so briefly rather than flagging
it. Don't invent issues — if it all checks out, say so.`;
